export default __webpack_public_path__ + "static/media/watch.ea9b3454.jpeg";